<template>
    <v-card>
      <v-card-title>
        <span class="headline">Make</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs5 v-if="newMake">
                <v-text-field :label="labels.vehMake" v-model="vehMakeForm.vehMake" :error-messages="errors.collect('vehMake')" data-vv-name="vehMake" :data-vv-as="labels.vehMake" v-validate="'required|param|max:20'"></v-text-field>
              </v-flex>
              <v-flex xs5 v-else>
                <v-subheader class="queryLabel">{{labels.vehMake}}</v-subheader>
                <div class="title">{{vehMakeForm.vehMake}}</div>
              </v-flex>
              <v-flex>
                <v-text-field :label="labels.description" v-model="vehMakeForm.vehMakeDesc" :error-messages="errors.collect('description')" data-vv-name="description" :data-vv-as="labels.description" v-validate="'required|entry|max:100'"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'vehMakeForm': Object,
    'newMake': Boolean
  },
  data() {
    return {
      labels: {
        vehMake: 'Make Code*',
        description: 'Make Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.vehMakeForm.vehMake = undefined
      this.vehMakeForm.vehMakeDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newMake) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.vehicle.menu.createVehMake
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.vehMakeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.vehicle.menu.updateVehMake
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.vehMakeForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
